"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.test_json_data = {
    address: "Near to store Ms Rosa",
    age: "36",
    balanceDue1: 7956,
    balanceDue2: 7956,
    balanceDue3: 7069,
    balanceDue4: 7068,
    balanceDue5: 4951,
    balanceDue6: 4950,
    balanceDueTotal: 39950,
    campus_ABQ: "yes",
    cancellationFee1: "0",
    cancellationFee2: "0",
    cancellationFee3: "0",
    cancellationFee4: "0",
    cancellationFee5: "0",
    cancellationFee6: "0",
    cancellationFeeTotal: 0,
    cashPayment_yes: "yes",
    city: "Cochabamba",
    classAttendanceTime: "9AM_2PM_Monday_Thursday",
    code1: "123123",
    code2: "1231232",
    code3: "123123123",
    code4: "123123",
    code5: "123123",
    code6: "123123",
    date: "January 2020",
    dateOfBirth: "09/01/2020",
    endDate1: "2021-01-31T04:00:00.000Z",
    endDate2: "2021-05-16T04:00:00.000Z",
    endDate3: "2021-09-05T04:00:00.000Z",
    endDate4: "2022-01-09T04:00:00.000Z",
    endDate5: "2022-03-13T04:00:00.000Z",
    endDate6: "2022-05-12T04:00:00.000Z",
    fee1: "0",
    fee2: "0",
    fee3: "0",
    fee4: "0",
    fee5: "427",
    fee6: "426",
    feeTotal: 853,
    financialAid_yes: "yes",
    firstName: "Franklin test",
    homePhone: "123123123123",
    lastName: "Franklin test",
    maidenName: "some mainden",
    maritalStatus: "single",
    nameHighSchool: "CochabambaBolivia12345",
    namePreviousCollege: "Colegio Arquidiosesano Pio XII",
    no: "123",
    other: "Some other 22222",
    other1: "0",
    other2: "0",
    other3: "0",
    other4: "0",
    other5: "0",
    other6: "0",
    otherTotal: 0,
    paymentReceive1: "0",
    paymentReceive2: "0",
    paymentReceive3: "0",
    paymentReceive4: "0",
    paymentReceive5: "0",
    paymentReceive6: "0",
    paymentReceiveTotal: 0,
    placeOfBirth: "Cochabambamanta",
    previousTraining: "Some previous training",
    programCheckbox_associate: "yes",
    programCheckbox_certificate: "no",
    programCost1: 7956,
    programCost2: 7956,
    programCost3: 7069,
    programCost4: 7068,
    programCost5: 4951,
    programCost6: 4950,
    programCostTotal: 39950,
    programGraduationDate: "2022-05-12T04:00:00.000Z",
    programHour: "99",
    programLength: "19.5",
    programOptions: "ATM",
    programType: "Quarter_Credit",
    ssn: "1234556",
    state: "DC",
    supplies1: "614",
    supplies2: "493",
    supplies3: "0",
    supplies4: "0",
    supplies5: "0",
    supplies6: "0",
    suppliesTotal: 1107,
    termBeginning: "10052020",
    textbooks1: "273",
    textbooks2: "394",
    textbooks3: "0",
    textbooks4: "0",
    textbooks5: "0",
    textbooks6: "0",
    textbooksTotal: 667,
    transferCreditPending_yes: "yes",
    tuition1: "7069",
    tuition2: "7069",
    tuition3: "7069",
    tuition4: "7068",
    tuition5: "4524",
    tuition6: "4524",
    tuitionTotal: 37323,
    type: "Some typooooo",
    veteranBenefit_yes: "yes",
    veteranStudent_yes: "yes",
    volume: "IX11",
    workPhone: "59175930626",
    yearGraduated: "2012",
    zipCode: "0000",
    financial__tuition: "435"
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVzdF9qc29uX2RhdGEuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbIndyYXBwZXIvdGVzdF9qc29uX2RhdGEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBYSxRQUFBLGNBQWMsR0FBRztJQUMxQixPQUFPLEVBQUUsdUJBQXVCO0lBQ2hDLEdBQUcsRUFBRSxJQUFJO0lBQ1QsV0FBVyxFQUFFLElBQUk7SUFDakIsV0FBVyxFQUFFLElBQUk7SUFDakIsV0FBVyxFQUFFLElBQUk7SUFDakIsV0FBVyxFQUFFLElBQUk7SUFDakIsV0FBVyxFQUFFLElBQUk7SUFDakIsV0FBVyxFQUFFLElBQUk7SUFDakIsZUFBZSxFQUFFLEtBQUs7SUFDdEIsVUFBVSxFQUFFLEtBQUs7SUFDakIsZ0JBQWdCLEVBQUUsR0FBRztJQUNyQixnQkFBZ0IsRUFBRSxHQUFHO0lBQ3JCLGdCQUFnQixFQUFFLEdBQUc7SUFDckIsZ0JBQWdCLEVBQUUsR0FBRztJQUNyQixnQkFBZ0IsRUFBRSxHQUFHO0lBQ3JCLGdCQUFnQixFQUFFLEdBQUc7SUFDckIsb0JBQW9CLEVBQUUsQ0FBQztJQUN2QixlQUFlLEVBQUUsS0FBSztJQUN0QixJQUFJLEVBQUUsWUFBWTtJQUNsQixtQkFBbUIsRUFBRSx5QkFBeUI7SUFDOUMsS0FBSyxFQUFFLFFBQVE7SUFDZixLQUFLLEVBQUUsU0FBUztJQUNoQixLQUFLLEVBQUUsV0FBVztJQUNsQixLQUFLLEVBQUUsUUFBUTtJQUNmLEtBQUssRUFBRSxRQUFRO0lBQ2YsS0FBSyxFQUFFLFFBQVE7SUFDZixJQUFJLEVBQUUsY0FBYztJQUNwQixXQUFXLEVBQUUsWUFBWTtJQUN6QixRQUFRLEVBQUUsMEJBQTBCO0lBQ3BDLFFBQVEsRUFBRSwwQkFBMEI7SUFDcEMsUUFBUSxFQUFFLDBCQUEwQjtJQUNwQyxRQUFRLEVBQUUsMEJBQTBCO0lBQ3BDLFFBQVEsRUFBRSwwQkFBMEI7SUFDcEMsUUFBUSxFQUFFLDBCQUEwQjtJQUNwQyxJQUFJLEVBQUUsR0FBRztJQUNULElBQUksRUFBRSxHQUFHO0lBQ1QsSUFBSSxFQUFFLEdBQUc7SUFDVCxJQUFJLEVBQUUsR0FBRztJQUNULElBQUksRUFBRSxLQUFLO0lBQ1gsSUFBSSxFQUFFLEtBQUs7SUFDWCxRQUFRLEVBQUUsR0FBRztJQUNiLGdCQUFnQixFQUFFLEtBQUs7SUFDdkIsU0FBUyxFQUFFLGVBQWU7SUFDMUIsU0FBUyxFQUFFLGNBQWM7SUFDekIsUUFBUSxFQUFFLGVBQWU7SUFDekIsVUFBVSxFQUFFLGNBQWM7SUFDMUIsYUFBYSxFQUFFLFFBQVE7SUFDdkIsY0FBYyxFQUFFLHdCQUF3QjtJQUN4QyxtQkFBbUIsRUFBRSxnQ0FBZ0M7SUFDckQsRUFBRSxFQUFFLEtBQUs7SUFDVCxLQUFLLEVBQUUsa0JBQWtCO0lBQ3pCLE1BQU0sRUFBRSxHQUFHO0lBQ1gsTUFBTSxFQUFFLEdBQUc7SUFDWCxNQUFNLEVBQUUsR0FBRztJQUNYLE1BQU0sRUFBRSxHQUFHO0lBQ1gsTUFBTSxFQUFFLEdBQUc7SUFDWCxNQUFNLEVBQUUsR0FBRztJQUNYLFVBQVUsRUFBRSxDQUFDO0lBQ2IsZUFBZSxFQUFFLEdBQUc7SUFDcEIsZUFBZSxFQUFFLEdBQUc7SUFDcEIsZUFBZSxFQUFFLEdBQUc7SUFDcEIsZUFBZSxFQUFFLEdBQUc7SUFDcEIsZUFBZSxFQUFFLEdBQUc7SUFDcEIsZUFBZSxFQUFFLEdBQUc7SUFDcEIsbUJBQW1CLEVBQUUsQ0FBQztJQUN0QixZQUFZLEVBQUUsaUJBQWlCO0lBQy9CLGdCQUFnQixFQUFFLHdCQUF3QjtJQUMxQyx5QkFBeUIsRUFBRSxLQUFLO0lBQ2hDLDJCQUEyQixFQUFFLElBQUk7SUFDakMsWUFBWSxFQUFFLElBQUk7SUFDbEIsWUFBWSxFQUFFLElBQUk7SUFDbEIsWUFBWSxFQUFFLElBQUk7SUFDbEIsWUFBWSxFQUFFLElBQUk7SUFDbEIsWUFBWSxFQUFFLElBQUk7SUFDbEIsWUFBWSxFQUFFLElBQUk7SUFDbEIsZ0JBQWdCLEVBQUUsS0FBSztJQUN2QixxQkFBcUIsRUFBRSwwQkFBMEI7SUFDakQsV0FBVyxFQUFFLElBQUk7SUFDakIsYUFBYSxFQUFFLE1BQU07SUFDckIsY0FBYyxFQUFFLEtBQUs7SUFDckIsV0FBVyxFQUFFLGdCQUFnQjtJQUM3QixHQUFHLEVBQUUsU0FBUztJQUNkLEtBQUssRUFBRSxJQUFJO0lBQ1gsU0FBUyxFQUFFLEtBQUs7SUFDaEIsU0FBUyxFQUFFLEtBQUs7SUFDaEIsU0FBUyxFQUFFLEdBQUc7SUFDZCxTQUFTLEVBQUUsR0FBRztJQUNkLFNBQVMsRUFBRSxHQUFHO0lBQ2QsU0FBUyxFQUFFLEdBQUc7SUFDZCxhQUFhLEVBQUUsSUFBSTtJQUNuQixhQUFhLEVBQUUsVUFBVTtJQUN6QixVQUFVLEVBQUUsS0FBSztJQUNqQixVQUFVLEVBQUUsS0FBSztJQUNqQixVQUFVLEVBQUUsR0FBRztJQUNmLFVBQVUsRUFBRSxHQUFHO0lBQ2YsVUFBVSxFQUFFLEdBQUc7SUFDZixVQUFVLEVBQUUsR0FBRztJQUNmLGNBQWMsRUFBRSxHQUFHO0lBQ25CLHlCQUF5QixFQUFFLEtBQUs7SUFDaEMsUUFBUSxFQUFFLE1BQU07SUFDaEIsUUFBUSxFQUFFLE1BQU07SUFDaEIsUUFBUSxFQUFFLE1BQU07SUFDaEIsUUFBUSxFQUFFLE1BQU07SUFDaEIsUUFBUSxFQUFFLE1BQU07SUFDaEIsUUFBUSxFQUFFLE1BQU07SUFDaEIsWUFBWSxFQUFFLEtBQUs7SUFDbkIsSUFBSSxFQUFFLGVBQWU7SUFDckIsa0JBQWtCLEVBQUUsS0FBSztJQUN6QixrQkFBa0IsRUFBRSxLQUFLO0lBQ3pCLE1BQU0sRUFBRSxNQUFNO0lBQ2QsU0FBUyxFQUFFLGFBQWE7SUFDeEIsYUFBYSxFQUFFLE1BQU07SUFDckIsT0FBTyxFQUFFLE1BQU07SUFDZixrQkFBa0IsRUFBRSxLQUFLO0NBQzVCLENBQUEifQ==